import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import DashboardIcon from "@mui/icons-material/Dashboard";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export default function Sidebar() {
  const theme = useTheme();

  // 👇 auto collapse on <=900px
  const isMdDown = useMediaQuery("(max-width:900px)");

  // 👇 manual toggle state
  const [manualCollapsed, setManualCollapsed] = useState(false);

  // 👇 final collapse logic
  const isCollapsed = isMdDown || manualCollapsed;

  const menuItems = [
    { label: "Dashboard", icon: <DashboardIcon /> },
    { label: "Packages", icon: <Inventory2Icon /> },
    { label: "Access Rights", icon: <LockPersonIcon /> },
  ];

  return (
    <Box
      sx={{
        width: isCollapsed ? 60 : 200,
        height: "100vh",
        bgcolor: "rgb(68 155 168)",
        color: "#fff",
        px: isCollapsed ? 1 : 2,
        py: 2,
        transition: "width 0.3s ease",
        position: "relative",
      }}
    >
      {/* 🔁 TOGGLE ARROW */}
      {!isMdDown && (
        <IconButton
          onClick={() => setManualCollapsed(!manualCollapsed)}
          size="small"
          sx={{
            position: "absolute",
            top: 50,
            right: isCollapsed ? -14 : -14,
            bgcolor: "#506D70",
            color: "#fff",
            "&:hover": {
              bgcolor: "#3B5457",
            },
          }}
        >
          {isCollapsed ? (
            <ChevronRightIcon fontSize="small" />
          ) : (
            <ChevronLeftIcon fontSize="small" />
          )}
        </IconButton>
      )}

      {/* Logo / Title */}
      <Typography
        variant="h6"
        sx={{
          mb: 3,
          mt: 1,
          textAlign: isCollapsed ? "center" : "left",
          whiteSpace: "nowrap",
        }}
      >
        {isCollapsed ? "ST" : "Sales Track"}
      </Typography>

      {/* Menu */}
      {menuItems.map((item) => (
        <Box
          key={item.label}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            py: 1.2,
            px: isCollapsed ? 1 : 0,
            cursor: "pointer",
            borderRadius: 1,
            opacity: item.label === "Packages" ? 1 : 0.8,
            justifyContent: isCollapsed ? "center" : "flex-start",
            "&:hover": {
              bgcolor: "rgba(255,255,255,0.08)",
            },
          }}
        >
          {item.icon}

          {!isCollapsed && (
            <Typography sx={{ fontSize: "1rem" }}>
              {item.label}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}
